<header class="pt-2">
    <div class="d-md-flex">
      <div class="col-xs-12 col-md-6 align-items-baseline">
        <img class="me-2 mb-1" src="assets/images/{{'header.logo' | translate}}" [style.height.px]="logoHeight">
      </div>
      <div class="col-xs-12 col-md-6 d-md-flex justify-content-xs-start justify-content-md-end smaller-font">
          <ul class="nav nav-pills" >
            <li class="nav-item nav-link p-0 pe-3" *ngIf="showPhone">
                <a href="tel:{{'support.phone' | translate}}" class="link">
                  <i class="fa-solid fa-phone" title="Phone"></i> {{'support.phone' | translate}}</a>
            </li>
            <li class="nav-item nav-link p-0" *ngIf="showEmail">
              <a href="mailto:{{'support.email' | translate}}" class="link" ><i
                  class="fa-solid fa-envelope" title="Email"></i> {{'support.email' | translate}}</a>
            </li>
            <li class="nav-item nav-link p-0" *ngIf="showSite">
              <a href="{{'support.site' | translate}}" class="link" ><i
                  class="fa-solid fa-globe" title="{{siteLabel}}"></i> {{siteLabel}}</a>
            </li>
          </ul>
        </div>
    </div>
</header>

